if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('testMode');
}

angular.module('testMode', []);
